module.exports = __webpack_public_path__ + "static/app-store.955504c6.png";